module.exports = __webpack_public_path__ + "static/img/img1.81fd197f.png";